import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-device25",
  "use": "icon-device25-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-device25\"><path d=\"M953.6 249.6l-172.8-172.8c-12.8-6.4-19.2-12.8-25.6-12.8H121.6c-32 0-57.6 25.6-57.6 57.6v780.8c0 32 25.6 57.6 57.6 57.6H896c32 0 57.6-25.6 57.6-57.6V268.8c6.4-6.4 0-19.2 0-19.2zM601.6 128h89.6v192c0 6.4-6.4 12.8-19.2 12.8H601.6V128z m-64 0v211.2h-192c-6.4 0-19.2-6.4-19.2-19.2V128h211.2z m-256 768v-128c0-19.2 19.2-38.4 38.4-38.4h384c12.8 0 19.2 6.4 25.6 12.8 6.4 6.4 12.8 12.8 12.8 25.6v128H281.6z m614.4 0h-89.6v-128c0-25.6-12.8-51.2-32-70.4s-44.8-32-70.4-32H320c-57.6 0-102.4 44.8-102.4 102.4v128H128V128h134.4v192c0 44.8 38.4 76.8 83.2 76.8h326.4c44.8 0 83.2-38.4 83.2-76.8V147.2L896 281.6V896z\" fill=\"\" p-id=\"10577\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-device25.svg
// module id = mmQl
// module chunks = 177